<template>
  <div class="overflow-x-hidden">
    <a-drawer
      :zIndex="8990"
      class="edit-device-mp"
      :wrapClassName="`drawer`"
      placement="right"
      :afterVisibleChange="loadMap"
      :visible="visible"
      :title="$t(`mygwf.components.Label.measuring_point`)"
      @close="$emit('close')"
    >
      <div class="flex flex-col">
        <BaseMap
          ref="map"
          v-if="loaded"
          class="shadow-lg h-96"
          :startPopulating="populateMap"
          :allowNewMarker="false"
          isEditable
          @update="
            measuringPoint.lat = $event.lat
            measuringPoint.lng = $event.lng
          "
          :groups="[{list: mapData, label: `Editing`}]"
          :optionType="{value: 'mp_id'}"
        />
        <base-button
          class="self-end mt-4 text-sm"
          :action="'search_by_address'"
          size="sm"
          @click="search"
        >
          <base-icon icon="search" class="mr-1" />
        </base-button>
        <div class="flex flex-col space-y-5 shadow border py-4 px-14 mt-5">
          <div class="flex items-center justify-between border-b px-1 py-2">
            <span class="w-40">Name:</span>
            <base-input class="min-w-max max-w-fit" v-model.trim="measuringPoint.mp_name" />
          </div>
          <div class="flex items-center justify-between border-b px-1 py-2">
            <span class="w-40">
              ID:
              <dd v-if="uniqueMpIdError" class="text-red-default text-xs">
                ID must be unique
              </dd></span
            >

            <base-input
              class="min-w-max max-w-fit"
              v-model.trim="measuringPoint.measuring_point_id"
            />
          </div>

          <div class="flex items-center space-x-4 justify-between">
            <div class="flex flex-col flex-grow space-y-1">
              <div>{{ $t(`mygwf.components.Label.lat`) }} :</div>
              <base-input v-model="measuringPoint.lat" />
            </div>

            <div class="flex flex-col flex-grow space-y-1">
              <div>{{ $t(`mygwf.components.Label.long`) }}:</div>
              <base-input v-model="measuringPoint.lng" />
            </div>
            <base-button
              context="outline"
              size="sm"
              :action="'update_map'"
              :disabled="noMpChanges"
              @click="updateMap"
            >
              <base-icon icon="map-pin" class="mr-2" />
            </base-button>
          </div>
        </div>
        <FormError :errors="errors" class="mt-2 text-center" />

        <div class="flex justify-end space-x-4 mt-6">
          <!-- <base-button
            size="sm"
            action="reset_changes"
            :disabled="isSaving || !noChanges"
            context="secondary"
            class="w-fit"
            @click="resetData"
          >
            <base-icon icon="refresh" class="mr-2" />
          </base-button> -->
          <base-button size="sm" :loading="isSaving" @click="onSubmit" action="save" class="w-fit"
            ><base-icon icon="edit" />
          </base-button>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import Drawer from 'ant-design-vue/lib/drawer'
import 'ant-design-vue/lib/drawer/style/index.css'
import {BaseMap, BaseButton, BaseIcon, BaseInput} from '@/components/base'
import FormError from '@/components/shared/FormError.vue'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    measuringPoint: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loaded: false,
      mapData: [],
      populateMap: false,
      isSaving: false,
      startingPoint: {...this.measuringPoint},
      errors: {},
      uniqueMpIdError: false,
    }
  },
  computed: {
    pointCompany: {
      get() {
        return this.measuringPoint.company
      },
      set(value) {
        return this.$store.getters['companies/list'].filter(c => c.id === value)[0]
      },
    },
    noChanges() {
      return JSON.stringify(this.startingPoint) === JSON.stringify(this.measuringPoint)
    },
    noMpChanges() {
      return (
        JSON.stringify(this.startingPoint.lat) === JSON.stringify(this.measuringPoint.lat) &&
        JSON.stringify(this.startingPoint.lng) === JSON.stringify(this.measuringPoint.lng)
      )
    },
  },
  components: {
    'a-drawer': Drawer,
    BaseMap,
    BaseButton,
    BaseIcon,
    BaseInput,
    FormError,
  },
  methods: {
    renderMarkersOnMap() {
      this.populateMap = false
      this.$nextTick(() => (this.populateMap = true))
    },
    search() {
      document.getElementsByClassName('geocoder-control-input leaflet-bar')[0].click()
    },
    updateMap() {
      this.renderMarkersOnMap()
      setTimeout(() => {
        this.$refs.map.openPopups(this.measuringPoint.mp_id)
      }, 300)
    },
    // resetData() { WILL NOT FUNCTION NOW
    //   this.measuringPoint = {...this.startingPoint}

    //   this.$refs.map.updateMap(this.measuringPoint)
    // },
    loadMap(visible) {
      this.mapData[0] = this.measuringPoint
      this.loaded = visible
      this.$nextTick(() => {
        this.populateMap = true
        this.$nextTick(() => this.$refs.map.openPopups(this.measuringPoint.mp_id))
      })
    },
    onSubmit() {
      this.isSaving = true
      if (this.noChanges) {
        setTimeout(() => {
          this.errors = {}
          this.uniqueMpIdError = false
          this.isSaving = false
        }, 800)
        return
      }
      let payload = {
        name: this.measuringPoint.mp_name,
        mpid: this.measuringPoint.measuring_point_id,
        lat: parseFloat(this.measuringPoint.lat).toFixed(6),
        lng: parseFloat(this.measuringPoint.lng).toFixed(6),
        //company: this.pointCompany,
      }
      if (this.measuringPoint.meter_id) {
        payload = {...payload, meter_id: this.measuringPoint.meter_id}
      }
      this.$store
        .dispatch('measuringPoints/update', {id: this.measuringPoint.mp_id, body: payload})
        .then(point => {
          this.$store.dispatch('app/notification', {type: 'success', group: 'app', text: `updated`})
          this.$emit('refresh')

          this.startingPoint = {...this.measuringPoint}
          this.errors = {}
          this.uniqueMpIdError = false
        })
        .catch(errors => {
          console.log(errors)
          this.errors = errors
          if (errors.detail.non_field_errors) {
            this.uniqueMpIdError = true
          }
        })
        .finally(() => (this.isSaving = false))
    },
  },
}
</script>
